import { useLeagues } from "../../../ducks/leagues";
import { useLobby } from "../../../ducks/lobby";
import LeagueCard from "./LeagueCard";

export default function LeagueCardContainer({ isDesktop }) {
  const { modeId } = useLobby();
  const { leagueScores } = useLeagues();

  const leagueScore = leagueScores[modeId];

  const props = {
    modeId,
    leagueScore,
    isDesktop,
  };

  return <LeagueCard {...props} />;
}
